import { CANNABIS_INVITATION_CONFIG } from './cannabis-invitation.config';
import * as i0 from "@angular/core";
const STORAGE_KEY_POPUP_DISMISSED = 'cannabis_invitation_popup_dismissed';
export class CannabisInvitationService {
    get today() {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }
    get start() {
        const d = new Date(CANNABIS_INVITATION_CONFIG.startDate);
        d.setHours(0, 0, 0, 0);
        return d;
    }
    get end() {
        const d = new Date(CANNABIS_INVITATION_CONFIG.endDate);
        d.setHours(23, 59, 59, 999);
        return d;
    }
    isInvitationActive() {
        const t = this.today.getTime();
        return t >= this.start.getTime() && t <= this.end.getTime();
    }
    shouldShowPopup() {
        if (!this.isInvitationActive())
            return false;
        const dismissed = localStorage.getItem(STORAGE_KEY_POPUP_DISMISSED);
        if (!dismissed)
            return true;
        const dismissedDate = new Date(dismissed);
        dismissedDate.setHours(0, 0, 0, 0);
        return dismissedDate.getTime() < this.start.getTime();
    }
    markPopupDismissed() {
        localStorage.setItem(STORAGE_KEY_POPUP_DISMISSED, new Date().toISOString());
    }
    get config() {
        return CANNABIS_INVITATION_CONFIG;
    }
    /** URL segura para archivos con espacios o caracteres especiales en el nombre */
    pdfAssetUrl(path) {
        const segments = path.split('/').map((s) => encodeURIComponent(s));
        return `/assets/${segments.join('/')}`;
    }
    getInvitationPdfItems() {
        return CANNABIS_INVITATION_CONFIG.invitationPdfs.map((p) => {
            const fileName = p.path.split('/').pop() || 'documento.pdf';
            return {
                label: p.label,
                bannerLabel: p.bannerShortLabel || p.label,
                url: this.pdfAssetUrl(p.path),
                downloadFileName: fileName
            };
        });
    }
    /**
     * Abre el PDF en una pestaña nueva (visor del navegador) y dispara la descarga del archivo.
     * `window.open` va en el mismo tick del clic para reducir bloqueo de pop-ups.
     */
    openPdfPreviewAndDownload(event, assetUrl, downloadFileName) {
        event.preventDefault();
        event.stopPropagation();
        const absolute = assetUrl.startsWith('http://') || assetUrl.startsWith('https://')
            ? assetUrl
            : `${window.location.origin}${assetUrl.startsWith('/') ? assetUrl : '/' + assetUrl}`;
        const viewer = window.open(absolute, '_blank', 'noopener,noreferrer');
        if (viewer) {
            viewer.opener = null;
        }
        requestAnimationFrame(() => {
            const a = document.createElement('a');
            a.href = absolute;
            a.setAttribute('download', downloadFileName);
            a.rel = 'noopener';
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });
    }
}
CannabisInvitationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CannabisInvitationService_Factory() { return new CannabisInvitationService(); }, token: CannabisInvitationService, providedIn: "root" });
